import freshmarket11 from "../assets/Freshmarket-shop11.webm";
import freshmarket2 from "../assets/freshmarket2.webp";
import freshmarket3 from "../assets/freshmarket3.webp";
import freshmarket4 from "../assets/freshmarket4.webp";
import vacation from "../assets/vacation-project.webp";
import vacation1 from "../assets/vacation-project1.webp";
import vacation2 from "../assets/vacation-project2.webp";
import vacation3 from "../assets/vacation-project3.webp";
import todo from "../assets/todo-list.webm";
import todolist2 from "../assets/todolist2.webp";
import todolist3 from "../assets/todolist3.webp";
import csv_parser from "../assets/csv-parser3.webm";
import csv_parser2 from "../assets/csv-parser2.webm";
import weather_project from "../assets/weather-project.webm";
import pixaImages from "../assets/pixaImage.webm";

export const projects = [
  {
    id: 1,
    title: "PixaImage — Full-Stack Gallery",
    description:
      "Full-stack photo gallery built with Node.js, Express, React (Vite), and Redux Toolkit. Features pagination, sorting, caching, and a layered architecture for clean separation of concerns.",
    stack: ["React", "Node.js", "Express", "Redux", "Vite"],
    images: [{ src: pixaImages, type: "video" }],
    live: "https://pixaimage.onrender.com/",
    repository: "https://github.com/ronM3/pixaImage-react-node",
  },
  {
    id: 2,
    title: "Weatherwise Forecast",
    description:
      "Weather forecast app using HTML5 Geolocation and the OpenWeatherMap API. 7-day forecast, dynamic background, data caching, and a Module Revealing Architecture for clean code organisation.",
    stack: ["JavaScript", "HTML5", "CSS3", "REST APIs"],
    images: [{ src: weather_project, type: "video" }],
    live: "https://weatherwise.onrender.com/",
    repository: "https://github.com/ronM3/Wether-Forecast-vanila-javascript",
  },
  {
    id: 3,
    title: "Freshmarket Shop",
    description:
      "E-commerce shop with Angular and RxJS on the frontend and a Node.js/Express/MySQL backend. Includes reactive forms, file upload, authentication with bcrypt, and full error handling.",
    stack: ["Angular", "RxJS", "Node.js", "MySQL", "Bootstrap"],
    user: "Demo — got@gmail.com / 123456",
    images: [
      { src: freshmarket11, type: "video" },
      { src: freshmarket2, type: "image", width: 1200, height: 563 },
      { src: freshmarket3, type: "image", width: 1200, height: 564 },
      { src: freshmarket4, type: "image", width: 1917, height: 902 },
    ],
    live: "https://freshmarketapp.herokuapp.com/",
    repository: "https://github.com/ronM3/Freshmarket-shop",
  },
  {
    id: 4,
    title: "Ultimate Vacations",
    description:
      "Vacation tagging and discovery platform with real-time follower counts via Socket.IO. Login-protected, with React on the frontend and a Node.js/MySQL backend.",
    stack: ["React", "Node.js", "MySQL", "Socket.IO"],
    user: "Demo — tony / 123456",
    images: [
      { src: vacation, type: "image", width: 693, height: 326 },
      { src: vacation2, type: "image", width: 1200, height: 564 },
      { src: vacation1, type: "image", width: 1200, height: 564 },
      { src: vacation3, type: "image", width: 1918, height: 900 },
    ],
    live: "https://uvacations.herokuapp.com/",
    repository: "https://github.com/ronM3/vacations-client",
  },
  {
    id: 5,
    title: "Customizable To-Do List",
    description:
      "Friendly, customisable task manager with add, edit, and delete functionality. Built in Vanilla JavaScript with dark mode support and full mobile responsiveness.",
    stack: ["JavaScript", "HTML5", "CSS3", "Bootstrap"],
    images: [
      { src: todo, type: "video" },
      { src: todolist2, type: "image", width: 693, height: 326 },
      { src: todolist3, type: "image", width: 1200, height: 564 },
    ],
    live: "https://customtodo.onrender.com/",
    repository: "https://github.com/ronM3/Customizable-To-Do-List",
  },
  {
    id: 6,
    title: "Node.js CSV Parser",
    description:
      "API endpoint that parses CSV files line by line as arrays, plus a second endpoint that fetches remote data by ID and returns a formatted CSV file. Includes persistent caching and custom error handling.",
    stack: ["Node.js", "Express"],
    images: [
      { src: csv_parser2, type: "video" },
      { src: csv_parser, type: "video" },
    ],
    repository: "https://github.com/ronM3/Node.js-csv-reader",
  },
];
